<!-- This is shown in the main navigation menu and also the qeditor menu. -->
<ul class="navbar-nav ms-auto me-1 above-sticky">
  <li class="nav-item my-auto" ngbDropdown display="dynamic" placement="bottom-end">
    <button class="btn btn-transparent no-caret" ngbDropdownToggle id="helpDropdown" role="button">
      <cds-icon shape="SecurityAndWarningsQuestion" sizePx="20" />
    </button>
    <div ngbDropdownMenu aria-labelledby="helpDropdown" class="dropdown-menu shadow-lg">
      <a ngbDropdownItem [href]="HELP_DOCS_MAIN" target="_blank" class="my-1" i18n>
        <cds-icon shape="EducationBookOpen" class="me-1" /> Documentation
        <small i18n-ngbTooltip ngbTooltip="Opens in a new tab" class="ext-link small">
          <cds-icon shape="ArrowsArrowSquareOut" />
        </small>
      </a>
      <a
        ngbDropdownItem
        href="https://success.copado.com/s/contactsupport"
        target="_blank"
        class="my-1"
        i18n
      >
        <cds-icon shape="SecurityAndWarningsQuestion" class="me-1" /> Request Support
        <small i18n-ngbTooltip ngbTooltip="Opens in a new tab" class="ext-link small">
          <cds-icon shape="ArrowsArrowSquareOut" />
        </small>
      </a>
    </div>
  </li>
</ul>
